import { Link } from 'react-router-dom';

const ServiceDetail = () => {
  const services = [
    {
      icon: 'ri-building-2-line',
      title: 'Commercial Fit-Outs',
      description: [
        'Complete electrical installations for new commercial spaces, retail outlets, office environments, and industrial facilities. Our team designs and implements efficient electrical systems tailored to your business requirements.',
        'We work closely with builders, architects, and property managers to deliver fit-outs that meet project timelines and budget constraints while maintaining the highest standards of workmanship.',
        'From initial design consultation through to final testing and certification, we ensure your commercial space is powered safely and efficiently.',
      ],
      includes: [
        'Power distribution and circuit design',
        'Lighting layout and installation',
        'Data and communication cabling',
        'Emergency lighting systems',
        'Switchboard installation',
        'Final compliance testing and certification',
      ],
      image: 'https://public.readdy.ai/ai/img_res/477ec163d6c0ab33e47154f088103c36.jpg',
    },
    {
      icon: 'ri-dashboard-line',
      title: 'Switchboard Installations & Upgrades',
      description: [
        'Modern switchboard solutions including new installations, upgrades, and replacements for commercial and industrial properties. We ensure safe, efficient power distribution throughout your facility.',
        'Aging switchboards can pose safety risks and limit your electrical capacity. Our upgrade services bring your electrical infrastructure up to current standards while accommodating future expansion needs.',
        'All switchboard work is performed by licensed electricians and includes comprehensive testing to ensure reliable operation and compliance with Australian Standards.',
      ],
      includes: [
        'Switchboard design and specification',
        'Main switchboard installations',
        'Sub-board installations',
        'Circuit breaker upgrades',
        'Safety switch installation',
        'Load balancing and capacity upgrades',
      ],
      image: 'https://readdy.ai/api/search-image?query=professional%20electrical%20switchboard%20installation%20with%20organized%20circuit%20breakers%20and%20wiring%20in%20industrial%20setting%20showing%20modern%20electrical%20panel%20with%20safety%20switches%20and%20clean%20cable%20management%20in%20commercial%20facility&width=700&height=500&seq=service-switchboard&orientation=landscape',
    },
    {
      icon: 'ri-file-shield-2-line',
      title: 'Compliance Testing & Certification',
      description: [
        'Comprehensive electrical testing and certification services to ensure your systems meet all Australian Standards and regulatory requirements. Essential for property transactions, insurance, and ongoing safety compliance.',
        'Our testing procedures identify potential hazards, verify system integrity, and provide documented evidence of compliance. We issue certificates that satisfy legal requirements and insurance obligations.',
        'Regular compliance testing is crucial for maintaining safe electrical systems and avoiding costly penalties or insurance issues.',
      ],
      includes: [
        'Test and tag services',
        'Electrical safety inspections',
        'RCD testing and verification',
        'Thermal imaging assessments',
        'AS/NZS 3000 compliance reports',
        'Certification documentation',
      ],
      image: 'https://readdy.ai/api/search-image?query=electrician%20performing%20electrical%20testing%20and%20compliance%20inspection%20with%20digital%20testing%20equipment%20and%20clipboard%20in%20commercial%20building%20showing%20professional%20safety%20assessment%20and%20certification%20process&width=700&height=500&seq=service-compliance&orientation=landscape',
    },
    {
      icon: 'ri-search-eye-line',
      title: 'Fault Finding & Diagnostics',
      description: [
        'Expert troubleshooting and diagnostic services to identify and resolve electrical issues quickly, minimising downtime for your business. Our experienced team uses advanced testing equipment to pinpoint problems efficiently.',
        'Electrical faults can disrupt operations and pose safety risks. We respond promptly to diagnose issues, provide clear explanations, and implement effective solutions that prevent recurrence.',
        'From intermittent problems to complete system failures, our systematic approach ensures accurate diagnosis and reliable repairs.',
      ],
      includes: [
        'Circuit tracing and testing',
        'Power quality analysis',
        'Equipment malfunction diagnosis',
        'Wiring fault identification',
        'Emergency fault response',
        'Repair and rectification work',
      ],
      image: 'https://readdy.ai/api/search-image?query=electrician%20using%20diagnostic%20testing%20equipment%20and%20multimeter%20to%20troubleshoot%20electrical%20fault%20in%20commercial%20facility%20showing%20professional%20problem%20solving%20and%20technical%20expertise%20with%20electrical%20systems&width=700&height=500&seq=service-faultfinding&orientation=landscape',
    },
    {
      icon: 'ri-lightbulb-flash-line',
      title: 'Lighting & Power Installations',
      description: [
        'Energy-efficient lighting solutions and power installations tailored to commercial requirements. We design and install systems that enhance productivity, reduce energy costs, and meet workplace safety standards.',
        'Modern lighting technology offers significant energy savings and improved working environments. We specify and install LED systems, emergency lighting, and intelligent controls that deliver long-term value.',
        'Power installations are designed for reliability and future expansion, ensuring your facility can accommodate growing electrical demands.',
      ],
      includes: [
        'LED lighting installations',
        'Emergency and exit lighting',
        'Power point installations',
        'Three-phase power systems',
        'Lighting control systems',
        'Energy-efficient upgrades',
      ],
      image: 'https://readdy.ai/api/search-image?query=modern%20commercial%20LED%20lighting%20installation%20in%20office%20space%20with%20energy%20efficient%20ceiling%20lights%20and%20power%20outlets%20showing%20bright%20professional%20environment%20and%20contemporary%20electrical%20infrastructure&width=700&height=500&seq=service-lighting&orientation=landscape',
    },
    {
      icon: 'ri-tools-line',
      title: 'Preventative Maintenance',
      description: [
        'Scheduled maintenance programs to keep your electrical systems running reliably, preventing costly breakdowns and ensuring continuous operation. Regular maintenance extends equipment life and maintains safety compliance.',
        'Our maintenance programs are tailored to your facility\'s specific needs, with scheduled inspections, testing, and servicing that identify potential issues before they cause problems.',
        'Preventative maintenance is a cost-effective approach that reduces emergency callouts, minimises downtime, and ensures your electrical systems remain compliant and efficient.',
      ],
      includes: [
        'Scheduled electrical inspections',
        'Switchboard maintenance',
        'Connection tightening and cleaning',
        'Thermal imaging surveys',
        'Equipment testing and servicing',
        'Maintenance reporting and documentation',
      ],
      image: 'https://readdy.ai/api/search-image?query=electrician%20performing%20preventative%20maintenance%20inspection%20on%20commercial%20electrical%20equipment%20with%20checklist%20and%20tools%20in%20industrial%20facility%20showing%20professional%20servicing%20and%20system%20care&width=700&height=500&seq=service-maintenance&orientation=landscape',
    },
  ];

  return (
    <section>
      {services.map((service, index) => (
        <div
          key={index}
          className={`py-20 ${index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}`}
        >
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${index % 2 === 1 ? 'lg:flex-row-reverse' : ''}`}>
              <div className={index % 2 === 1 ? 'lg:order-2' : ''}>
                <div className="w-14 h-14 flex items-center justify-center mb-6">
                  <i className={`${service.icon} text-gold text-6xl`}></i>
                </div>
                <h2 className="text-4xl font-bold text-navy mb-6">{service.title}</h2>
                <div className="h-0.5 w-20 bg-gold mb-8"></div>

                {service.description.map((paragraph, pIndex) => (
                  <p key={pIndex} className="text-charcoal text-base leading-relaxed mb-4">
                    {paragraph}
                  </p>
                ))}

                <h3 className="text-navy font-bold text-lg mt-8 mb-4">Includes:</h3>
                <ul className="space-y-3 mb-8">
                  {service.includes.map((item, iIndex) => (
                    <li key={iIndex} className="flex items-start gap-3">
                      <i className="ri-checkbox-circle-fill text-gold text-xl mt-0.5 w-5 h-5 flex items-center justify-center flex-shrink-0"></i>
                      <span className="text-charcoal">{item}</span>
                    </li>
                  ))}
                </ul>

                <Link
                  to="/contact"
                  className="inline-flex items-center gap-2 border-2 border-navy text-navy px-8 py-3 rounded-lg font-bold text-sm tracking-wider hover:bg-navy hover:text-white transition-all whitespace-nowrap cursor-pointer"
                >
                  REQUEST SERVICE QUOTE
                </Link>
              </div>

              <div className={index % 2 === 1 ? 'lg:order-1' : ''}>
                <div className="relative">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-auto rounded-lg shadow-lg border-4 border-gold object-cover"
                    style={{ objectPosition: 'center' }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </section>
  );
};

export default ServiceDetail;